module.exports = __webpack_public_path__ + "static/media/transactionVerificationFailed.59ccc16e.svg";